






















import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { getProgress } from "@/api/common";

@Component({
  name: "UploadProgress"
})
export default class extends Vue {
  @Emit('closeDialog')
  public closeDialog() {
    return false;
  }

  @Prop({
    type: Object,
    required: true,
  })
  private data!: { uuid: number, fileName: string, progressVisible: boolean, uploadStatus: string };

  private percentage = 0; // 上传进度
  private wrong = 0; //错误的文件上传数量
  private status: 'start' | 'stop' = 'start';

  created() {
    // 延迟轮询状态
    setTimeout(() => {
      this.getUploadProgress();
    }, 1000);
  }

  beforeDestroy() {
    this.status = 'stop';
  }

  private getUploadProgress() {
    getProgress(this.data.uuid).then((res: any) => {
      const progress = res.data || {};
      if (this.data.uploadStatus !== 'done') {
        if (progress) {
          this.percentage = Math.round((Number((progress.current + (progress.wrong || 0)) / progress.total) ||
            0) * 100);
          setTimeout(this.loopProgress, 1000);
        } else {
          setTimeout(this.loopProgress, 1000);
        }
      } else if (progress.success) {
        this.percentage = Math.round((Number((progress.current + (progress.wrong || 0)) / progress.total) ||
          0) * 100);
      }
      this.wrong = progress.wrong || 0;
    }).catch((e) => {
    });
  }

  private loopProgress() {
    if (this.percentage !== 100 && this.status === 'start') {
      this.getUploadProgress();
    }
  }

  private getUploadStatus() {
    return this.data.uploadStatus === 'done' && this.wrong > 0;
  }

  private customColorMethod(percentage: number) {
    if (percentage < 30) {
      return '#909399';
    } else if (percentage < 70) {
      return '#e6a23c';
    } else {
      return '#67c23a';
    }
  }
}
